import React, {Component, Fragment} from 'react';
import Graph from 'react-graph-vis';

function LightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] === "#") {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col,16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if  (r < 0) r = 0;
    var b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if  (b < 0) b = 0;
    var g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

const options = {
    height: '100%',
    layout: {
        hierarchical: false
    },
    edges: {
      arrows: {
        to:     {enabled: true, scaleFactor: 0.2, type:'arrow'},
        middle: {enabled: false, scaleFactor:1, type:'arrow'},
        from:   {enabled: false, scaleFactor:1, type:'arrow'}
      },
      scaling:{
        min: 1,
        max: 5,
        label: {
          enabled: false
        }
      },
      font: {
        color: "#000000",
        strokeWidth: 0, // px
        strokeColor: '#ffffff',
        align: 'top'
      },
      color: "#000000"
    },
    nodes: {
      shape : 'dot',
      size : 8,
      chosen: {
        node: function(values, id, selected, hovering) {values.color = LightenDarkenColor(values.color, -40);}
      }
    },
    physics: {
      solver: 'forceAtlas2Based'
    },
    interaction: {
      hover:true
    }
};


class GraphVis extends Component {

  render() {
    const { loading, graph, events } = this.props

    return (
          <Fragment>
            <div style={{height: '60vh'}}>
              {loading ? 'Loading...' : ' '}
              <Graph graph={graph} options={options} events={events}/>
            </div>
          </Fragment>
            )
      }
    }

export default GraphVis;
